import React, { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { push } from '@lagunovsky/redux-react-router'
import i18n from 'simple-react-i18n'
import InstVisitInfos from './validation/InstVisitInfos'
import InstVisitConclusion from './validation/InstVisitConclusion'
import InstVisitActions from './validation/InstVisitActions'
import InstVisitModifications from './validation/InstVisitModifications'
import InstallationAction from '../../actions/InstallationAction'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import { H_CAMPAIGN_INSTALLATION_VISIT } from '../../../account/constants/AccessRulesConstants'
import { useParams } from 'react-router-dom'
import useTitle from 'utils/customHook/useTitle'
import CmsAction from 'events/actions/CmsAction'
import InstVisitDiagnostic from './validation/InstVisitDiagnostic'
import InstVisitDanger from './validation/InstVisitDanger'
import { Card, CardContent, Stack } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'

const InstallationVisitSummary = () => {
    const dispatch = useDispatch()

    const { idInstallation, id } = useParams()

    useEffect(() => {
        if (!componentHasHabilitations(H_CAMPAIGN_INSTALLATION_VISIT)) { // A modifier quand react-router sera à jour
            dispatch(push('/unauthorized'))
            return
        }
        dispatch(InstallationAction.fetchInstallation(idInstallation))
        dispatch(InstallationAction.fetchVisit(idInstallation, id))
        $('.material-tooltip').remove()
    }, [])

    const {
        visit,
        campaign,
        installation,
        cmsSurveyId,
    } = useSelector(store => ({
        visit: store.InstallationReducer.visit,
        campaign: store.CampaignReducer.campaign,
        installation: store.InstallationReducer.installation,
        cmsSurveyId: store.EventsReducer.cmsSurveyId,
    }), shallowEqual)

    useEffect(() => {
        if (cmsSurveyId && installation.id) {
            dispatch(CmsAction.fetchCMSSurveyRestricted(cmsSurveyId, installation.id))
        }
    }, [cmsSurveyId, installation.id])

    useEffect(() => {
        if (visit.visitDate) {
            dispatch(CmsAction.fetchCMSSurveyId(visit.visitDate))
        }
    }, [visit.visitDate])

    useTitle(() => {
        return [
            {
                title: i18n.installation,
                href: '/installation',
            },
            {
                title: i18n.campaigns,
                href: '/installation/campaign',
            },
            {
                title: campaign.name || id,
                href: `/installation/campaign/${id}/dashboard`,
            },
            {
                title: `${installation.code ? `[${installation.code}]` : ''} - ${installation.name ? installation.name : ''}`,
                href: `/station/installation/${installation.id}`,
            },
        ]
    }, [installation, campaign])

    const params = {
        readMode: true,
        visit,
        summary: true,
    }

    return (
        <Stack spacing={1} margin={1}>
            <Card>
                <CardTitle title={i18n.visit} />
                <CardContent>
                    <InstVisitInfos {...params}/>
                </CardContent>
            </Card>
            {
                cmsSurveyId && (
                    <>
                        <Card>
                            <CardTitle title={i18n.diagnostic} />
                            <CardContent>
                                <InstVisitDiagnostic {...params} />
                            </CardContent>
                        </Card>
                        <Card>
                            <CardTitle title={i18n.dangers} />
                            <CardContent>
                                <InstVisitDanger {...params} />
                            </CardContent>
                        </Card>
                    </>
                )
            }
            <Card>
                <CardTitle title={i18n.modifications} />
                <CardContent>
                    <InstVisitModifications {...params} />
                </CardContent>
            </Card>
            <Card>
                <CardTitle title={i18n.actions} />
                <CardContent>
                    <InstVisitActions {...params}/>
                </CardContent>
            </Card>
            <Card>
                <CardTitle title={i18n.conclusion}/>
                <CardContent>
                    <InstVisitConclusion {...params}/>
                </CardContent>
            </Card>
        </Stack>
    )
}

InstallationVisitSummary.propTypes = {
}

export default InstallationVisitSummary